const HERO_SELECTOR = '[data-uc-wholesale-hero]'
const REGISTER_SELECTOR = '[data-uc-wholesale-register]'
const TRIGGER_SELECTOR = '[data-uc-wholesale-register-trigger]'

function getWholesaleElements(root: ParentNode = document) {
	const hero = root.querySelector<HTMLElement>(HERO_SELECTOR)
	const register = root.querySelector<HTMLElement>(REGISTER_SELECTOR)

	return { hero, register }
}

function toggleWholesaleRegister(isOpen: boolean, root: ParentNode = document) {
	const { hero, register } = getWholesaleElements(root)
	if (!hero || !register) return

	hero.hidden = isOpen
	register.hidden = !isOpen
	register.dataset.ucWholesaleRegisterOpen = `${isOpen}`
	document.querySelectorAll<HTMLElement>(TRIGGER_SELECTOR).forEach((trigger) => {
		trigger.setAttribute('aria-expanded', `${isOpen}`)
	})

	if (!isOpen) return

	requestAnimationFrame(() => {
		register.scrollIntoView({ behavior: 'smooth', block: 'start' })
	})
}

function syncWholesaleRegister(root: ParentNode = document) {
	const { register } = getWholesaleElements(root)
	if (!register) return

	const isOpen = register.dataset.ucWholesaleRegisterOpen === 'true'
	toggleWholesaleRegister(isOpen, root)
}

function initWholesaleRegisterToggle() {
	syncWholesaleRegister()

	document.addEventListener('click', (event) => {
		const target =
			event.target instanceof Element
				? event.target.closest<HTMLElement>(TRIGGER_SELECTOR)
				: null

		if (!target) return

		event.preventDefault()
		toggleWholesaleRegister(true)
	})

	document.addEventListener('shopify:section:load', () => {
		syncWholesaleRegister()
	})
}

initWholesaleRegisterToggle()
